import React from 'react';
import { Control } from 'react-hook-form';

import cardValidator from '@ott/utility-card-validator';

import { RefillFormData } from '../../../types';
import CVVField from '../blocks/CVVField/CVVField';
import { RefillCard, RefillFormType } from '../types';
import { DEFAULT_BACK_REF } from './constants';

import styles from '../RefillForm.scss';

const getCardIssuingNetworkName = (cardNumber: string) => {
  const bin = cardNumber.slice(0, 6);
  const { card: validatedCard } = cardValidator.number(bin);

  return validatedCard?.type.replace(/\W/, '') || 'default';
};

const formatIssuingNetworkName = (value: string) => {
  const firstLetter = value.slice(0, 1).toUpperCase();
  const otherLetters = value.slice(1).toLowerCase();

  return firstLetter + otherLetters;
};

const getVariants = (
  cards: RefillCard[],
  activeCardID: string,
  isLoading: boolean,
  control: Control<RefillFormType, object>
) => {
  const cardsVariants = cards.map((card) => {
    const issuingNetworkName = getCardIssuingNetworkName(card.cardMask) as string;

    const formatedIssuingNetworkName = formatIssuingNetworkName(issuingNetworkName);

    return {
      value: card.cardId,
      title: card.cardNumber,
      text: (
        <div className={styles.textWrapper} data-id={card.cardId}>
          <span>{formatedIssuingNetworkName}</span>
          {activeCardID === card.cardId && <CVVField control={control} disabled={isLoading} />}
        </div>
      ),
      disabled: card.status !== 'IsActive' || isLoading,
      icons: [card.issuingNetwork],
    };
  });

  return cardsVariants;
};

const getQueryParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
};

const prepareData = (data: RefillFormType): RefillFormData => {
  const amount = data.amount;
  const cvc = data.cardCVV;
  const backRef = DEFAULT_BACK_REF;

  if (Boolean(data.selectedId)) {
    return {
      cvc,
      amount,
      backRef,
      cardId: data.selectedId,
    };
  }

  return {
    cvc,
    amount,
    backRef,
    cardNumber: data.cardNumber,
    expiredDate: data.expMonth + data.expYear,
    holderName: data.cardHolder ?? '',
    saveCard: Boolean(data.saveCard),
  };
};

export { getVariants, getQueryParams, prepareData };
